import { render, staticRenderFns } from "./CardChoice.vue?vue&type=template&id=993b260e&scoped=true&"
import script from "./CardChoice.vue?vue&type=script&lang=js&"
export * from "./CardChoice.vue?vue&type=script&lang=js&"
import style0 from "./CardChoice.vue?vue&type=style&index=0&id=993b260e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993b260e",
  null
  
)

export default component.exports